import React from 'react';
import { IToggleUpDown } from '../../../types/IToggleUpDown';
import { ToggleIconStyle, ToggleUpDownBody } from '../../styles/forms';

export const ToggleUpDown = (props: IToggleUpDown) => {
  const { onUp, onDown, iconSize, disabledUp, disabledDown, disabledColor, disabledAll } = props;

  return (
    <ToggleUpDownBody>
      <ToggleIconStyle
        icon={'symbol-triangle-up'}
        {...{ iconSize, disabledColor, onClick: onUp, disabled: disabledAll || disabledUp }}
      />
      <ToggleIconStyle
        icon={'symbol-triangle-down'}
        {...{ iconSize, disabledColor, onClick: onDown, disabled: disabledAll || disabledDown }}
      />
    </ToggleUpDownBody>
  );
};
